import React, { useEffect } from 'react'
import { Text, Flex, Link, ArcadeIcon } from '@afterpaytouch/core'
import { Trans } from '../../../utils/convergence'
import { useTranslation } from '../../../utils/convergence'
import { useAppRouter } from '../../../state'
import { Route } from '../../../config/router'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../../utils/responsive'

export const CardExpiryWarning = (): JSX.Element => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const { textSize, smallTextSize } = useCheckoutSizes()

  const handleAddPaymentMethod = (): void => {
    router.push(Route.NEW_PAYMENT_METHOD)
  }

  const components = {
    addPaymentMethodLink: <Link kind='Underline' onClick={handleAddPaymentMethod} />,
  }

  useEffect(() => {
    router.prefetch(Route.NEW_PAYMENT_METHOD)
  }, [])

  return (
    <Flex alignItems='flex-start' className={styles.container}>
      <ArcadeIcon.CardAdd size='Medium' color='Black' />
      <Flex direction='column' className={styles.textContainer}>
        <Text size={textSize} bold>
          {t('summary:paymentMethodTitle')}
        </Text>
        <Text size={smallTextSize}>
          <Trans i18nKey='summary:error.cardExpiry.message_cannotSwitchInline' components={components} />
        </Text>
      </Flex>
    </Flex>
  )
}
